module.exports = __webpack_public_path__ + "/static/assets/65be0c15b22044e29d75368efe3c0203.gif";